import { NextPage, NextPageContext } from "next";

import CandidateJobs from "@/views/jobs/ForCandidates";
import JobsViewForRecuriter from "@/views/jobs/ForRecuriter";
import React from "react";

import { JobType } from "@/types/job";

import api from "@/services/api";
import axiosInstance from "@/services/api/axiosInstance";
import publicApi from "@/services/publicApi";

import { COOKIE, USER_ROLE } from "@/constants";

import getCookiesFromPageRequest from "@/helpers/getCookiesFromPageRequest";

const defaultFilters = {
  ordering: "-modified_ts",
  status: "Active",
};

const JobsPage: NextPage = ({
  isAuthenticatedAs,
  serverFetchedJobDetails,
  serverFetchedJobList,
}: {
  isAuthenticatedAs?: string[];
  serverFetchedJobDetails?: JobType;
  serverFetchedJobList?: { count: number; results: JobType[]; next: string };
}) => {
  if (!isAuthenticatedAs)
    return (
      // public page
      <CandidateJobs
        serverFetchedJobDetails={serverFetchedJobDetails}
        serverFetchedJobList={serverFetchedJobList}
        isPagePublic
      />
    );
  else {
    if (isAuthenticatedAs.includes(USER_ROLE.CANDIDATE))
      return (
        <CandidateJobs
          serverFetchedJobDetails={serverFetchedJobDetails}
          serverFetchedJobList={serverFetchedJobList}
        />
      );
    else if (isAuthenticatedAs.includes(USER_ROLE.CLIENT))
      return (
        <CandidateJobs
          serverFetchedJobDetails={serverFetchedJobDetails}
          serverFetchedJobList={serverFetchedJobList}
          isPagePublic
        />
      );
    else if (isAuthenticatedAs.includes(USER_ROLE.RECRUITER))
      return <JobsViewForRecuriter />;
    else {
      //TODO: posthog
      return <></>;
    }
  }
};
export default JobsPage;

export async function getServerSideProps(context: NextPageContext) {
  // TODO: Refactor this function (Yaseen)
  const cookies = getCookiesFromPageRequest(context.req);
  const isAuthenticatedAs =
    cookies[COOKIE.ZELACCESS] &&
    cookies[COOKIE.ROLES] &&
    decodeURIComponent(cookies[COOKIE.ROLES]).split("|");
  if (!isAuthenticatedAs) {
    const jobId = context.query.id;
    // on request of page detail page
    if (jobId && typeof jobId === "string") {
      try {
        const res = await publicApi.getJobById(jobId);
        return {
          props: {
            serverFetchedJobDetails: res.data,
          },
        };
      } catch (error) {
        // TODO:posthog
        console.error(error);
        return { props: {} };
      }
    }
    // on request of job list page
    try {
      const res = await publicApi.getJobs(defaultFilters);
      return {
        props: {
          serverFetchedJobList: res.data,
        },
      };
    } catch (error) {
      // TODO:posthog
      // console.error(error.data);
      console.error("error: public job listing");
      return { props: {} };
    }
  } else {
    // if authenticated
    // get job id
    const jobId = context.query.id;
    // on request of page detail page
    if (jobId && typeof jobId === "string") {
      try {
        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${
          cookies[COOKIE.ZELACCESS]
        }`;
        const res = await api.company.getJobById(jobId);
        return {
          props: {
            serverFetchedJobDetails: res.data,
            isAuthenticatedAs,
          },
        };
      } catch (error) {
        // TODO:posthog
        console.error("error fetching private job id");
        return {
          props: {
            isAuthenticatedAs,
          },
        };
      }
    }

    if (isAuthenticatedAs.includes(USER_ROLE.RECRUITER)) {
      return {
        props: {
          isAuthenticatedAs,
        },
      };
    }

    // on request of job list page
    try {
      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${
        cookies[COOKIE.ZELACCESS]
      }`;
      const res = await api.company.getJobs(defaultFilters);
      return {
        props: {
          serverFetchedJobList: res.data,
          isAuthenticatedAs,
        },
      };
    } catch (error) {
      // TODO:posthog
      // console.error(error);
      console.error("error fetching private job list...");
      return {
        props: {
          isAuthenticatedAs,
        },
      };
    }
  }
}
